// redux/api/InboxApi.js
import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const InboxApi = createApi({
  reducerPath: "InboxApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["INBOX", "MESSAGES"],
  endpoints: (build) => ({
    getInboxList: build.query({
      query: ({ page = 1, limit = 20, search = "", unreadOnly = false }) => ({
        url: `/inbox?page=${page}&limit=${limit}&search=${search}&unreadOnly=${unreadOnly}`,
        method: "GET",
      }),
      providesTags: ["INBOX"],
    }),

    getMessageList: build.query({
      query: ({ phone, page = 1, limit = 50 }) => ({
        url: `/inbox/${phone}/messages?page=${page}&limit=${limit}`,
        method: "GET",
      }),
      providesTags: (result, error, { phone }) => [
        { type: "MESSAGES", id: phone },
      ],
    }),

    sendMessage: build.mutation({
      query: ({ phone, data }) => ({
        url: `/inbox/${phone}/send`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result, error, { phone }) => [
        "INBOX",
        { type: "MESSAGES", id: phone },
      ],
    }),

    getInboxStats: build.query({
      query: () => ({
        url: `/inbox/stats`,
        method: "GET",
      }),
      providesTags: ["INBOX"],
    }),
  }),
});

export const {
  useGetInboxListQuery,
  useGetMessageListQuery,
  useSendMessageMutation,
  useGetInboxStatsQuery,
  useLazyGetMessageListQuery,
} = InboxApi;
